import { toast } from 'react-toastify';

const customToast = () => {
	const showToast = (type = 'info', message = '', toastProps = {}) => {
		const props = { position: 'bottom-center', ...toastProps };

		switch (type) {
		case 'success': {
			toast.success(message, {
				toastId: 'success-toast',
				autoClose: 1000,
				...props
			});
			break;
		}

		case 'warning': {
			toast.warning(message, { toastId: 'warning-toast', ...props });
			break;
		}

		case 'error': {
			toast.error(message, { toastId: 'error-toast', ...props });
			break;
		}

		case 'info': {
			toast.info(message, { toastId: 'info-toast', ...props });
			break;
		}

		default: {
			toast.info(message, { toastId: 'default-toast', ...props });
		}
		}
	};

	return { showToast };
};

export default customToast;
